import React,{Component} from 'react';
import "./style.less";
import {NavBar,Toast,ListView,Icon} from "antd-mobile";
import {connect} from "react-redux";
import {current} from "../../../service/homeService";
let pageIndex = 1;
let pageSize = 10;
const dataError = require('../../../common/image/wrongData.png');
const black = require('../../../common/image/black.png');
const noOrder = require('../../../common/image//noOrder.png');
@connect(
    state => ({userInfo: state.userInfo}),
)
export default class HistoryShift extends Component{
    constructor(props) {
        super(props);
        const dataSource = new ListView.DataSource({
            rowHasChanged: (row1, row2) => row1 !== row2,
        });
        this.state = {
            OrderListData:[],
            dataSource,
            isLoading: true,
            notDataLoading:0,
        }
    };
    componentDidMount() {
        pageIndex = 1;
        let params={
            token: this.props.userInfo.token,
            data:{
                pageSize: pageSize,
                pageNum: 1,
                source:6,
                status:2
            }
        };
       this._getOrderList(params);
    }
    _getOrderList(params){
        current(params).then((res) => {
                if(res.data.code == "0000"){
                    console.log(res)
                    if (res.data.data.list.length > 0) {
                        this._setDataSource(res.data.data);
                        // this.setState({data:res.data.data.list})
                    }else{
                        this.setState({isLoading: false,notDataLoading:1});
                    }
                }else {
                    this.setState({notDataLoading:2,isLoading: false});
                    Toast.info(res.data.msg,3)
                }
            }).catch(function (error) {
            console.log(error);
        });
    };
     //数据拼接
     _setDataSource(data) {
        const allData = [...this.state.OrderListData, ...data.list];
        this.setState({
            dataSource:this.state.dataSource.cloneWithRows(allData),
            OrderListData: allData,
        });
        if (pageIndex * pageSize >= data.total) {
            this.setState({isLoading: false});
        }
    }
    //上拉加载
    _onEndReached = () => {
        if (this.state.isLoading) {
            let params = {
                token: this.props.userInfo.token,
                data:{
                    pageSize: pageSize,
                    pageNum: ++pageIndex,
                    source:6,
                    status:2,
                },
            };
            this._getOrderList(params);
        }
    };
    notData(){
        if(this.state.notDataLoading == 1){
            return <div className="noData">
                        <img src={noOrder} />
                        <p>暂无代下单记录</p>
                    </div>
        }else if(this.state.notDataLoading == 2){
            return <div className="noData">
                <img src={dataError} />
                <p>数据出错，请稍后再试！</p>
            </div>
        }else{
            return null
        }
    }
   
    render(){
        const _renderRow = (i, index, rowID) => (
            <div className="list" key={rowID}>
                <div className="top">
                    <span>行程编号  {i.shiftNum}</span>
                    <span>已完成</span>
                </div>
                <div className="middle">
                    <div className="body">
                        <div>{i.startCity}</div>
                        <div>
                            <div>{i.startDate} {i.weekend} {i.startTime}</div>
                            <img src={black}/>
                        </div>
                        <div>{i.endCity}</div>
                    </div>
                </div>
                <div className="bottom">
                   <span>{i.driverName}</span><span>{i.carNum}</span><span className="sold">已购：<span style={{color:"#3679FE"}}>{i.sold}人</span></span>
                </div>
                <div className="btnbox">
                    <button className='shouhuo' onClick={()=>this.props.history.push('/passengerList',{id:i.id})}>查看乘客明细</button>
                    <button className='shouhuo' onClick={()=>this.props.history.push('/bringGoodList',{id:i.id})}>查看带货订单</button>
                </div>
            </div>
        )
        return(
            <div className="historyShift">
                <NavBar
                    className="navBar"
                    mode="light"
                    icon={<i className="icon iconfont iconmorenfanhui" onClick={() => this.props.history.goBack()} />}
                >历史行程记录</NavBar>
                <div className="content">
                    {this.notData()}
                    {
                        this.state.notDataLoading == 0  ?
                            <ListView
                                ref={el => this.lv = el}
                                dataSource={this.state.dataSource}
                                renderFooter={() => (this.state.isLoading ? <Icon type="loading"/> : '没有更多')}
                                renderRow={_renderRow}
                                style={{
                                    height: '100%',
                                    overflow:'auto'
                                }}
                                onEndReached={this._onEndReached.bind(this)}
                                scrollRenderAheadDistance={300}
                                onEndReachedThreshold={30}
                            />: null
                    }        
                           
                </div>
            </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/container/Member/HistoryShift/index.js